import { wsConnect } from "../modules/websocket";


// connect to socket;
export const connectToSocket = () => (dispatch) => {
  let host = "wss://php1wss.myriaconnect.com"
  dispatch(wsConnect(host))


}
